<template>
  <div class="d-flex flex-column justify-start">
    <div class="font-weight-bold"><v-icon icon="mdi-bookmark-outline" color="primary" size="small"></v-icon> {{ tarif.nom }}: {{ tarif.get_default_price() }}€</div>
    <div>
      <div class="text-body-2 text-darkgrey" v-if="tarif.has_limitations()">{{ tarif.get_limitation() }}</div>
      <div v-if="tarif.has_upcoming_majoration()">
        <div class="text-body-2 text-darkgrey" v-for="(majoration, index_majoration) in tarif.get_upcoming_majorations()" :key="index_majoration">
          <b>{{ majoration.tarif }}€</b> à partir du {{ $moment(majoration.date).format("DD/MM/YYYY") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["tarif"],
};
</script>

<style lang="scss" scoped>
</style>